module.exports = __webpack_public_path__ + "images/2-h64632cea0f48018afed1a81a62e105c4.svg";